/* eslint-disable camelcase */
import { getHeaders } from './utils';

export function JoinRequest(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/join-request`, {
		method: 'POST',
		headers: getHeaders(token, meeting) as any,
		body: JSON.stringify({
			meeting,
		}),
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function ApproveJoinRequest(token: string, join_request: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/join-request`, {
		method: 'PUT',
		headers: getHeaders(token) as any,
		body: JSON.stringify({
			join_request,
		}),
	}).then((res) => res.ok).catch((error) => {
		console.error(error);
	});
}

export function RejectJoinRequest(token: string, join_request: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/join-request`, {
		method: 'DELETE',
		headers: getHeaders(token) as any,
		body: JSON.stringify({
			join_request,
		}),
	}).then((res) => res.ok).catch((error) => {
		console.error(error);
	});
}

export function CheckJoinRequest(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/join-request/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token, meeting) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetActiveRooms(token: string) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/active-rooms`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetIsLive(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/is-live/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token, meeting) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetRequiresApproval(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/approval-required/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token, meeting) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function GetPendingJoinRequests(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/join-requests/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}

export function CheckWatcherOnly(token: string, meeting: number) {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/watcher-only/${meeting}`, {
		method: 'GET',
		headers: getHeaders(token, meeting) as any,
	}).then((res) => {
		if (res.ok) {
			return res.json();
		}
		return null;
	}).catch((error) => {
		console.error(error);
	});
}
